import { render, staticRenderFns } from "./SortDialogForAdmin.vue?vue&type=template&id=0aca6222&scoped=true&"
import script from "./SortDialogForAdmin.vue?vue&type=script&lang=js&"
export * from "./SortDialogForAdmin.vue?vue&type=script&lang=js&"
import style0 from "./SortDialogForAdmin.vue?vue&type=style&index=0&id=0aca6222&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aca6222",
  null
  
)

export default component.exports